import _ from 'lodash';

import * as constants from './Referral.constants';
import * as services from './Referral.service';

const state = {
  refCode: '',
  refRecords: [],
  referalMoney: 0,
  referalPoint: 0,
  refereeMoney: 0,
  isRequest: false,
  res_chooseYzRefs: false,
};

const mutations = {
  [constants.GET_YZ_REFS_SUCCESS](state, payload) {
    if (undefined !== payload.refCode) {
      state.refCode = payload.refCode;
      state.refRecords = payload.refRecords;
      state.referalMoney = payload.referalMoney;
      state.referalPoint = payload.referalPoint;
      state.refereeMoney = payload.refereeMoney;
    }
  },

  [constants.CHOOSE_YZ_REFS_SUCCESS](state, payload) {
    const { seqId, res_chooseYzRefs } = payload;
    state.res_chooseYzRefs = res_chooseYzRefs;
    if (res_chooseYzRefs) {
      const refRecordChoosenIdx = _.findIndex(
        state.refRecords,
        (refRecord) => seqId === refRecord.seqId
      );
      let refRecordChoosen = state.refRecords[refRecordChoosenIdx];
      refRecordChoosen = {
        ...refRecordChoosen,
        hasChosen: 3,
      };
      state.refRecords.splice(refRecordChoosenIdx, 1, refRecordChoosen);
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getYzRefs({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getYzRefs(payload);
    commit(constants.GET_YZ_REFS_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async chooseYzRefs({ commit }, payload) {
    const res = await services.chooseYzRefs(payload);
    commit(constants.CHOOSE_YZ_REFS_SUCCESS, {
      seqId: payload.seqId,
      res_chooseYzRefs: res.data.data,
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
